import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-5"
}

import { withDefaults, watch, ref } from 'vue';
import { MoleculeCard } from '@/components/molecules';
import { AtomToogleButton, AtomChartQuadrant } from '@/components/atoms';
import VueHighcharts from 'vue3-highcharts';
import { IDataset, IOptions, IOptionsSelect, IToggleButon } from '@/types';

interface IProps {
  title: string;
  legend: boolean;
  type: string;
  textX?: string;
  textY?: string;
  label?: string;
  hasToggle?: boolean;
  buttons?: IToggleButon[];
  hasDropdownList?: boolean;
  optionsDropDown?: IOptionsSelect[];
  colorSeries: string;
  height?: number;
  hasTabs?: boolean;
  footer?: boolean;
  dataset: IDataset[];
  options?: IOptions;
  labels?: string[];
  maxY?: number;
  maxX?: number;
  titleY?: string;
  titleX?: string;
  hasFilters?: boolean;
  loading?: boolean;
  id: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsChartQuadrant',
  props: {
    title: { default: '' },
    legend: { type: Boolean, default: false },
    type: null,
    textX: null,
    textY: null,
    label: null,
    hasToggle: { type: Boolean },
    buttons: null,
    hasDropdownList: { type: Boolean },
    optionsDropDown: null,
    colorSeries: { default: '#000' },
    height: null,
    hasTabs: { type: Boolean, default: false },
    footer: { type: Boolean },
    dataset: null,
    options: null,
    labels: null,
    maxY: null,
    maxX: null,
    titleY: null,
    titleX: null,
    hasFilters: { type: Boolean },
    loading: { type: Boolean },
    id: null
  },
  emits: ['handleToggle', 'onChangeDropDownList', "onTootipUp", "onTootipDown"],
  setup(__props: any, { emit }) {

const props = __props as { title: string, legend: boolean, type: string, textX?: string, textY?: string, label?: string, hasToggle?: boolean, buttons?: IToggleButon[], hasDropdownList?: boolean, optionsDropDown?: IOptionsSelect[], colorSeries: string, height?: number, hasTabs: boolean, footer?: boolean, dataset: IDataset[], options?: IOptions, labels?: string[], maxY?: number, maxX?: number, titleY?: string, titleX?: string, hasFilters?: boolean, loading?: boolean, id: string };




function handleToogleChange($event) {
  emit('handleToggle', $event);
}


function onTootipUp($event) {
  emit('onTootipUp', $event);
}

function onTootipDown($event) {
  emit('onTootipDown', $event);
}
function handleChangeDropdownList(event) {
  emit('onChangeDropDownList', event);
}


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_unref(MoleculeCard), {
    loading: props.loading,
    footer: props.footer,
    onOnChangeDropDownList: handleChangeDropdownList,
    "has-dropdown-list": props.hasDropdownList,
    "options-drop-down": props.optionsDropDown,
    label: props.label,
    textTooltip: 'textTooltip',
    title: props.title,
    hasTabs: props.hasTabs
  }, {
    tabs: _withCtx(() => [
      _renderSlot(_ctx.$slots, "tabs")
    ]),
    default: _withCtx(() => [
      (props.hasToggle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(AtomToogleButton), {
              buttons: props.buttons ?? [],
              onHandleToggle: handleToogleChange
            }, null, 8, ["buttons"])
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "topfreeArea"),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: __props.hasFilters ? '8' : '12'
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AtomChartQuadrant), {
                dataset: props.dataset,
                labels: props.labels,
                "title-x": props.titleX,
                "title-y": props.titleY,
                "max-x": props.maxX,
                "max-y": props.maxY,
                onOnTootipUp: onTootipUp,
                onOnTootipDown: onTootipDown,
                id: props.id
              }, null, 8, ["dataset", "labels", "title-x", "title-y", "max-x", "max-y", "id"])
            ]),
            _: 1
          }, 8, ["cols"]),
          (__props.hasFilters)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "4"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "filters")
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["loading", "footer", "has-dropdown-list", "options-drop-down", "label", "title", "hasTabs"]))
}
}

})